import React, { useMemo, useCallback } from 'react'

import { useSigEventsEditMap } from '../../sigevents/hooks'
import { useEsri } from '../hooks'
import { BASE_URL, ICONS } from '../../constants'

import GraphicLayer from './GraphicLayer'

import { LOCATOR_URL } from '../constants'

const esriReqs = [
  'esri/tasks/Locator',
  'esri/geometry/Point',
  'esri/geometry/SpatialReference',
]

const getSigEventSymbol = (incident) => {
  const size = '50px'

  const iconPath = `${BASE_URL}${ICONS.AI.ACTIVE.DIR}`
  const icon =
    (incident && incident.type && incident.type.icon) ||
    'SigEventIconsOther.png'

  return {
    type: 'picture-marker',
    url: `${iconPath}${icon}`,
    width: size,
    height: size,
  }
}

const getSigEventGeometry = (longitude, latitude) => ({
  type: 'point',
  x: longitude || 0,
  y: latitude || 0,
})

const getSigEventAttributes = (id) => ({
  id,
})

const SigEventsEditLayer = ({ map, view }) => {
  const [ready, { Locator, Point, SpatialReference }] = useEsri(esriReqs)
  const [
    {
      sigEvent: { id, latitude, longitude },
      incident,
      editorIsOpen,
    },
    { move },
  ] = useSigEventsEditMap()

  const locator = useMemo(() => {
    if (ready) {
      return new Locator({
        url: LOCATOR_URL,
        outSpatialReference: new SpatialReference({ wkid: 4326 }),
      })
    } else {
      return null
    }
  }, [ready, Locator, SpatialReference])

  const graphics = useMemo(
    () =>
      editorIsOpen
        ? [
            {
              geometry: getSigEventGeometry(longitude, latitude),
              symbol: getSigEventSymbol(incident),
              attributes: getSigEventAttributes(id),
            },
          ]
        : [],
    [id, latitude, longitude, incident, editorIsOpen]
  )

  const onClick = useCallback(
    async (lng, lat) => {
      if (ready && editorIsOpen) {
        try {
          const address = await locator.locationToAddress({
            location: new Point({
              longitude: lng,
              latitude: lat,
              spatialReference: new SpatialReference({ wkid: 4326 }),
            }),
          })
          move(
            lng,
            lat,
            `${address.attributes.Street} ${address.attributes.City}, ${address.attributes.State} ${address.attributes.ZIP}`
          )
        } catch (e) {
          move(lng, lat, ' ')
        }
      }
    },
    [move, ready, locator, Point, SpatialReference, editorIsOpen]
  )

  return (
    <GraphicLayer
      id="SigEventsEditLayer"
      map={map}
      view={view}
      graphics={graphics}
      onClick={onClick}
    />
  )
}

export default SigEventsEditLayer
